import { supabase } from "../lib/supabase";

/**
 * Save an other document record in the database
 */
export const createOtherDocument = async (
  bookingId: number,
  filePath: string,
  // Removed the description parameter since it's not being used in the database operation
) => {
  try {
    console.log("Creating other document record with:", {
      booking_id: bookingId,
      booking_other_documents_file: filePath
    });
    
    // Insert new document record
    const { data, error } = await supabase
      .from("booking_other_documents")
      .insert([
        {
          booking_id: bookingId,
          booking_other_documents_file: filePath
        }
      ])
      .select();

    if (error) {
      console.error("Database error during insert:", error);
      throw error;
    }

    return {
      success: true,
      data,
      error: null
    };
  } catch (error) {
    console.error("Error creating other document:", error);
    return {
      success: false,
      data: null,
      error
    };
  }
};

/**
 * Get all other documents for a booking
 */
export const getOtherDocuments = async (bookingId: number) => {
  try {
    console.log(`Fetching other documents for booking ID: ${bookingId}`);
    const { data, error } = await supabase
      .from("booking_other_documents")
      .select("*")
      .eq("booking_id", bookingId)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Database error during select:", error);
      throw error;
    }

    console.log(`Found ${data?.length || 0} other documents`);
    return {
      success: true,
      data,
      error: null
    };
  } catch (error) {
    console.error("Error fetching other documents:", error);
    return {
      success: false,
      data: [],
      error
    };
  }
};

/**
 * Delete an other document
 */
export const deleteOtherDocument = async (documentId: number) => {
  try {
    // Get the document record first to get the file path
    const { data: document, error: fetchError } = await supabase
      .from("booking_other_documents")
      .select("booking_other_documents_file")
      .eq("id", documentId)
      .single();

    if (fetchError) {
      console.error("Database error during fetch:", fetchError);
      throw fetchError;
    }

    // Delete from database
    const { error: deleteError } = await supabase
      .from("booking_other_documents")
      .delete()
      .eq("id", documentId);

    if (deleteError) {
      console.error("Database error during delete:", deleteError);
      throw deleteError;
    }

    // Delete file from storage if we have a file path
    if (document?.booking_other_documents_file) {
      const { error: storageError } = await supabase.storage
        .from("otherdocuments")
        .remove([document.booking_other_documents_file]);

      if (storageError) {
        console.error("Error deleting document file from storage:", storageError);
      }
    }

    return {
      success: true,
      error: null
    };
  } catch (error) {
    console.error("Error deleting other document:", error);
    return {
      success: false,
      error
    };
  }
}; 